import React, { useState } from "react";
import styled from "styled-components";
import NoSearchDataComponent from "../country-components/no-search-data";
import { useTable, usePagination, useRowSelect, useSortBy, useFlexLayout } from "react-table";
import BTable from "react-bootstrap/Table";
import LoaderImg from "@assets/images/loader.gif";
import AscSortIcon from "@assets/images/AscSortIcon";
import DescSortIcon from "@assets/images/DescSortIcon";
import DefaultSortIcon from "@assets/images/DefaultSortIcon";

import { ChevronLeft, ChevronRight } from "react-feather";
import commaFormat from "../../utils/commaFormat";
import { creditCostDetails } from "@components/templates/Profile/ProfileTable";
// Below code is for the Styling of the Table
const Styles = styled.div`
  margin-bottom: 0px !important;
  font-family: "Inter", sans-serif;
  .new-trademo-table-container {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    border-radius: 8px;
    ::-webkit-scrollbar {
      height: 6px;
    }
  }
  table {
    border-spacing: 0;
    font-weight: 500;
    .datatable-checkbox {
      font-size: 18px;
      cursor: pointer;
      padding: 0px;
      margin-top: -1px;
      vertical-align: middle;
      position: relative;
      :after {
        left: -1.05px;
      }
    }
    thead {
      font-size: 11px !important;
      border: 0;
      border-top: none;
      background-color: #fff;
      color: #101828;
      border-bottom: none !important;
      th {
        border-right: ${(props) => (props.hideBorder ? "none" : " 1px solid #eaecf0")};
        input {
          margin-bottom: 4px;
        }
        span {
          margin: auto 0px;
        }
        font-weight: 600;
        box-sizing: border-box;
        height: 40px;
        vertical-align: middle !important;
        border-top: none;
        .form-check {
          padding-left: 5px !important;
          position: relative;
          .form-check-input {
            position: absolute;
            margin-left: 0 !important;
            margin-top: 5px !important;
          }
        }
      }
    }
    tbody {
      tr {
        td {
          height: 48px;
          vertical-align: middle;
          color: rgba(0, 0, 0, 0.87) !important;
          font-weight: 400 !important;
          border-right: 1px solid #eaecf0;
          border-right: ${(props) => (props.hideBorder ? "none" : " 1px solid #eaecf0")};
        }
        svg {
          width: 18px;
          height: 18px;
          stroke: #667085;
          stroke-width: 2;
        }
        :hover {
          background-color: white !important;
        }
      }
    }
    tr {
      padding: 15px;
      font-size: 12px !important;
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border: ${(props) => (props.hideBorder ? "none" : " 1px solid #eaecf0")};
      border-bottom: ${(props) => (props.hideBorder ? " 1px solid #eaecf0" : "none")};
      border-left-style: none;
    }
  }
  .pagination {
    padding: 0.5rem;
  }
`;

const config = {
  end: "end",
  start: "start",
};

const StickyStartColumn = styled.th`
  position: sticky;
  left: ${(props) => (props.left ? props.left : "-1px")};
  min-width: ${(props) => (props.minWidth ? props.minWidth + "px" : "60px")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + "px" : "60px")};
  width: ${(props) => (props.minWidth ? props.minWidth + "px" : "60px")};
  background: white;
  z-index: 10;
`;

const StickyEndColumn = styled.th`
  position: sticky;
  right: ${(props) => (props.right ? props.right : "-1px")};
  min-width: ${(props) => (props.minWidth ? props.minWidth + "px" : "200px")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + "px" : "200px")};
  width: ${(props) => (props.minWidth ? props.minWidth + "px" : "200px")};
  background: white;
  cursor: pointer;
`;

const StickyStartRow = styled.td`
  position: sticky;
  left: ${(props) => (props.left ? props.left : "-1px")};
  min-width: ${(props) => (props.minWidth ? props.minWidth + "px" : "60px")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + "px" : "60px")};
  width: ${(props) => (props.minWidth ? props.minWidth + "px" : "60px")};
  background: white;
  text-transform: capitalize;
  z-index: 1;
`;

const StickyEndRow = styled.td`
  position: sticky;
  right: ${(props) => (props.right ? props.right : "-1px")};
  min-width: ${(props) => (props.minWidth ? props.minWidth + "px" : "60px")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth + "px" : "60px")};
  width: ${(props) => (props.minWidth ? props.minWidth + "px" : "60px")};
  background: white;
  cursor: pointer;
  text-align: center;
  z-index: 1;
`;

// End of the above code
// Below code is for the checkbox of the table for the selection
const IndeterminateCheckbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;
  React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return (
    <div className="d-flex  justify-content-center">
      <input type="checkbox" className="datatable-checkbox" ref={resolvedRef} {...rest} />
    </div>
  );
});

IndeterminateCheckbox.displayName = IndeterminateCheckbox;
// End of the above code
// below code is for the table function
function Table({ columns, data, isTwoLevel, totalRowsCount, currentPage, totalDataCount, tablePageSize, sortId, onChangePage, onSort, shipmentDefaultSortValue, onSelectedRowsChange, selectedObject, onChangePerPage, onTableObjectChange, isclearSelectedRows, sortOrderValue, defaultSortField, triggerSelectedDataObject, noDataComponent, hideSorting, hideSelection, clearFilter, type, options, isAtleastTwoColumnsSorted, blockAscSorting, hidePagination }) {
  // Use the state and functions returned from useTable to build your UI
  let sortBy = hideSorting
    ? []
    : {
        sortBy: [
          {
            id: sortId,
            desc: false,
          },
        ],
      };
  const [fromCount, setFromCount] = useState(null);
  const [toCount, setToCount] = useState(null);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    selectedFlatRows,
    toggleAllRowsSelected,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      pageCount: totalRowsCount,
      manualSortBy: false,
      manualPagination: false,
      useFlexLayout,
      autoResetSelectedRows: true,
      disableSortBy: true,
      initialState: {
        pageIndex: currentPage,
        pageSize: tablePageSize,
        ...sortBy,
        selectedRowIds: selectedObject,
      },
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      if (!hideSelection) {
        hooks.visibleColumns.push((columns) => [
          // Let's make a column for selection
          {
            id: "selection",
            disableResizing: true,
            minWidth: 40,
            width: 40,
            maxWidth: 40,
            // The header can use the table's getToggleAllRowsSelectedProps method
            // to render a checkbox
            Header: ({ getToggleAllPageRowsSelectedProps }) =>
              data.length > 0 &&
              columns.length > 0 && (
                <div className="m-auto">
                  <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps({ title: undefined })} />
                </div>
              ),
            // The cell can use the individual row's getToggleRowSelectedProps method
            // to the render a checkbox
            Cell: ({ row }) =>
              data.length > 0 &&
              columns.length > 0 && (
                <div>
                  <IndeterminateCheckbox {...row.getToggleRowSelectedProps({ title: undefined })} />
                </div>
              ),
          },
          ...columns,
        ]);
      }
    }
  );

  React.useEffect(() => {
    setPageSize(tablePageSize);
    setFromCount(currentPage * pageSize + 1);
    setToCount((currentPage + 1) * pageSize);
    if (!!selectedFlatRows && selectedFlatRows.length > 0 && !!isclearSelectedRows && isclearSelectedRows === true) {
      toggleAllRowsSelected(false);
    } else if (!!selectedFlatRows && selectedFlatRows.length > 0) {
      const selectedRowsData = selectedFlatRows.map((row) => row.original);
      onSelectedRowsChange(selectedRowsData);
    } else if (selectedFlatRows.length === 0 && data.length > 0) {
      onSelectedRowsChange([]);
    }
  }, [selectedFlatRows, isclearSelectedRows, data]);
  const previousPage = (pageIndex, pageSize) => {
    const currentPageIndex = pageIndex - 1;
    const tempTableObject = {
      currentPage: currentPageIndex,
      perPage: pageSize,
    };
    setFromCount(currentPageIndex * pageSize + 1);
    setToCount((currentPageIndex + 1) * pageSize);
    gotoPage(currentPageIndex);
    onTableObjectChange(tempTableObject);
    window.scrollTo(0, 200);
    triggerSelectedDataObject(data);
  };
  const nextPage = (pageIndex, pageSize) => {
    const currentPageIndex = pageIndex + 1;
    const tempTableObject = {
      currentPage: currentPageIndex,
      perPage: pageSize,
    };
    const requiredValueCount = pageIndex + 2;
    setFromCount(currentPageIndex * pageSize + 1);
    setToCount((currentPageIndex + 1) * pageSize);
    const requiredValue = requiredValueCount * pageSize + 1;
    if ((data[requiredValue] === undefined || data[requiredValue].s_no === undefined || (currentPageIndex * pageSize - pageSize > 0 && data[requiredValue - pageSize].s_no === undefined)) && Math.max(currentPageIndex * pageSize, totalDataCount) === totalDataCount && currentPageIndex * pageSize !== totalDataCount) {
      onChangePage(requiredValueCount, pageSize);
      onTableObjectChange(tempTableObject);
      gotoPage(currentPageIndex);
    } else {
      gotoPage(currentPageIndex);
      onTableObjectChange(tempTableObject);
    }
    window.scrollTo(0, 200);
    triggerSelectedDataObject();
  };

  const sortingHandler = (column) => {
    let index = shipmentDefaultSortValue && shipmentDefaultSortValue.find((item) => column.key === item.columnKey);
    if (!index) {
      index = shipmentDefaultSortValue && shipmentDefaultSortValue.find((item) => column.key === item.value);
    }
    if (!index) {
      index = shipmentDefaultSortValue && shipmentDefaultSortValue.find((item) => column.columnKey === item.altKey);
    }
    if (defaultSortField === index.columnKey) {
      if (sortOrderValue === "desc") {
        onSort(index.value, "asc");
      } else {
        onSort(index.value, "desc");
      }
    } else {
      onSort(index.value, "desc");
    }
    triggerSelectedDataObject();
  };
  const changePerPageTable = (perPagedata) => {
    let tempCurrentPageIndex = (fromCount - (fromCount % perPagedata)) / perPagedata - 1 > 0 ? (fromCount - (fromCount % perPagedata)) / perPagedata - 1 : 0;
    const tempTableObject = {
      currentPage: tempCurrentPageIndex,
      perPage: perPagedata,
    };
    setFromCount(tempTableObject.currentPage * tempTableObject.perPage + 1);
    setToCount((tempTableObject.currentPage + 1) * tempTableObject.perPage);
    const requiredValueCount = tempTableObject.currentPage;
    const requiredValue = tempTableObject.currentPage * tempTableObject.perPage + 1;
    if ((data[requiredValue] === undefined || data[requiredValue].s_no === undefined || (tempTableObject.currentPage * tempTableObject.perPage - tempTableObject.perPage > 0 && data[requiredValue - tempTableObject.perPage].s_no === undefined)) && Math.max(tempTableObject.currentPage * tempTableObject.perPage, totalDataCount) === totalDataCount && tempTableObject.currentPage * tempTableObject.perPage !== totalDataCount) {
      onChangePage(requiredValueCount, tempTableObject.perPage);
      onTableObjectChange(tempTableObject);
      onChangePerPage(tempTableObject.perPage);
      setPageSize(tempTableObject.perPage);
      setTimeout(() => {
        gotoPage(tempTableObject.currentPage);
      });
    } else {
      onTableObjectChange(tempTableObject);
      setPageSize(tempTableObject.perPage);
      setTimeout(() => {
        gotoPage(tempTableObject.currentPage);
      });
    }
    window.scrollTo(0, 200);
    triggerSelectedDataObject();
  };
  return (
    <>
      <div className="new-trademo-table-container">
        <BTable hover {...getTableProps()} className="trademo-table-body tw-relative tw-z-0">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                {headerGroup.headers.map((column) => (
                  <React.Fragment key={column.id}>
                    {column.sortable === true && !column.isSticky ? (
                      <th {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined, style: { maxWidth: column.maxWidth, minWidth: column.minWidth, width: column.minWidth } }))}>
                        <div onClick={(column.key === defaultSortField || column.key === undefined || column.columnKey === defaultSortField) && blockAscSorting ? () => null : () => sortingHandler(column)} className={`d-flex table-sorting-arrow h-100`}>
                          <span>{column.render("Header")}</span>
                          <span className={`tw-cursor-pointer ${sortOrderValue === "desc" && blockAscSorting && (column.key === defaultSortField || column.key === undefined || column.columnKey === defaultSortField) ? "!tw-cursor-not-allowed" : ""}`}>{column.sortable ? hideSelection && !isAtleastTwoColumnsSorted ? sortOrderValue === "asc" ? <AscSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : <DescSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : sortOrderValue === "desc" && (column.key === defaultSortField || column.key === undefined || column.columnKey === defaultSortField) ? <DescSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : sortOrderValue === "asc" && (column.key === defaultSortField || column.key === undefined || column.columnKey === defaultSortField) ? <AscSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : <DefaultSortIcon height={"18px"} width={"18px"} color={"#667085"} /> : ""}</span>
                        </div>
                      </th>
                    ) : column.sortable === true && column.isSticky ? (
                      <StickyStartColumn background={"#f9fafb"} left={column?.left} maxWidth={column.maxWidth} minWidth={column.minWidth} width={column.minWidth}>
                        <div {...column.getHeaderProps()} style={{ display: "flex" }} onClick={(column.key === defaultSortField || column.key === undefined || column.columnKey === defaultSortField) && blockAscSorting ? () => null : () => sortingHandler(column)}>
                          <span>{column.render("Header")}</span>
                          <span className={`tw-cursor-pointer ${sortOrderValue === "desc" && blockAscSorting && (column.key === defaultSortField || column.key === undefined || column.columnKey === defaultSortField) ? "!tw-cursor-not-allowed" : ""}`}>{column.sortable ? hideSelection ? sortOrderValue === "asc" ? <AscSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : <DescSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : sortOrderValue === "desc" && (column.key === defaultSortField || column.key === undefined || column.columnKey === defaultSortField) ? <DescSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : sortOrderValue === "asc" && (column.key === defaultSortField || column.key === undefined || column.columnKey === defaultSortField) ? <AscSortIcon height={"16px"} width={"16px"} color={"#101828"} /> : <DefaultSortIcon height={"18px"} width={"18px"} color={"#667085"} /> : ""}</span>
                        </div>
                      </StickyStartColumn>
                    ) : config.end === column.isSticky ? (
                      <StickyEndColumn background={"#f9fafb"} right={column?.right} maxWidth={column.maxWidth} minWidth={column.minWidth} width={column.minWidth}>
                        <div {...column.getHeaderProps()}>
                          <span>{column.render("Header")}</span>
                        </div>
                      </StickyEndColumn>
                    ) : config.start === column.isSticky || column.id === "selection" ? (
                      <StickyStartColumn background={"#f9fafb"} left={column?.left} maxWidth={column.maxWidth} minWidth={column.minWidth} width={column.minWidth}>
                        <div {...column.getHeaderProps()}>
                          <span>{column.render("Header")}</span>
                        </div>
                      </StickyStartColumn>
                    ) : (
                      <th style={{ maxWidth: column.maxWidth, minWidth: column.minWidth, width: column.minWidth }} {...column.getHeaderProps()}>
                        <span>{column.render("Header")}</span>
                      </th>
                    )}
                  </React.Fragment>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {!!page && page.length !== 0 ? (
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={i}>
                    {row.cells.map((cell) => {
                      return config.end === cell?.column?.isSticky ? (
                        <StickyEndRow right={cell?.column?.right} maxWidth={cell?.column.maxWidth} minWidth={cell?.column.minWidth} width={cell?.column.minWidth}>
                          <div {...cell.getCellProps()}>
                            <div className="text-wrap">{cell.render("Cell")}</div>
                          </div>
                        </StickyEndRow>
                      ) : config.start === cell?.column.isSticky || cell?.column.id === "selection" ? (
                        <StickyStartRow left={cell?.column?.left} maxWidth={cell?.column?.maxWidth} minWidth={cell?.column?.minWidth} width={cell?.column?.minWidth}>
                          <div {...cell.getCellProps()}>
                            <div className="text-wrap">{cell.render("Cell")}</div>
                          </div>
                        </StickyStartRow>
                      ) : (
                        <td {...cell.getCellProps()}>
                          <div className="text-wrap">{cell.render("Cell")}</div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr className="table-data-empty-state">
                <td colSpan={columns.length}>
                  {hideSelection ? (
                    <div className="no-data-column-data text-center">
                      <img className="py-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1670225921/intel/icons/no_result_illustration_avz4aw.svg" />
                      <p className="py-2">We couldn't find any matches based on your selected filters.</p>
                      <button onClick={clearFilter} className="btn btn-primary btn-sm trademo-new-btn">
                        Clear Filter
                      </button>
                    </div>
                  ) : columns.length === 0 && data.length > 0 ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100% - 146px)" }}>
                      <img src={LoaderImg} alt="Loading" />
                    </div>
                  ) : (
                    columns.length === 0 && data.length === 0 && <NoSearchDataComponent className={"!tw-w-auto"} content={noDataComponent} />
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </BTable>
      </div>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      {hideSelection && data.length === 0 ? (
        ""
      ) : (
        <div style={{ marginTop: hideSelection ? (data.length === 1 ? "0px" : data.length === 2 ? "0px" : "") : "" }} className={`trademo-table-pagination-container ${hidePagination ? "tw-hidden" : ""}`}>
          <div className="trademo-table-pagination-rpp-container">
            {type === "bol" ? <span className="mr-3">*This section shows the total count at the Bill of Lading level</span> : ""}
            <span className="trademo-table-pagination-rpp-text">{isTwoLevel ? "Rows per page" : "Result per page"} </span>
            <select
              className="trademo-table-pagination-rpp-select"
              value={pageSize}
              onChange={(e) => {
                changePerPageTable(Number(e.target.value), pageIndex);
              }}>
              {options
                ? options.map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))
                : [10, 20, 30].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
            </select>
          </div>
          <div className="trademo-table-count-display">
            <span className="trademo-table-count-text">
              {fromCount ? fromCount : ""}-{toCount ? (totalDataCount < toCount ? totalDataCount : toCount) : ""} of {commaFormat(totalDataCount)}
            </span>
          </div>
          <div className="trademo-table-button-container">
            <button className="trademo-table-arrow-button" onClick={() => previousPage(pageIndex, pageSize)} disabled={!canPreviousPage}>
              <ChevronLeft size={16} color="#8C8C8C" />
            </button>{" "}
            <button className="trademo-table-arrow-button" onClick={() => nextPage(pageIndex, pageSize)} disabled={!canNextPage}>
              <ChevronRight size={16} color="#8C8C8C" />
            </button>{" "}
          </div>
        </div>
      )}
    </>
  );
}
// End of the above code
const ReactTableTrademo = ({ tableName, isTwoLevel, secondLevelRowDropdownValue, columns, data, paginationTotalRows, onSelectedRowsChange, onSort, defaultSortField, paginationPerPage, onChangeRowsPerPage, onChangePage, paginationDefaultPage, noDataComponent, clearSelectedRows, selectedData, shipmentDefaultSortValue, onTableObjectChange, sortOrderValue, hideSorting, hidePagination, isRedirect, analyticsCountryID, pathname, currentUserPlan, hideSelection, clearFilter, type, hideBorder, fixSelection, options, isAtleastTwoColumnsSorted, StyledComponent = Styles, blockAscSorting = false }) => {
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const widthEnum = {
    defaultWidth: 190,
    emptyFieldValueWidth: 40,
    minimumValueWidth: 60,
    maximumValueWidth: 200,
    zeroGrow: 190,
    oneGrow: 210,
    twoGrow: 180,
  };
  let sortId = "";

  const setMaxWidth = (data) => {
    let returnValue = widthEnum.defaultWidth;
    if (!!data && !!data.maxWidth && data.maxWidth !== 0) {
      if (data.key !== undefined && data.key !== null && data.key.toLowerCase() === "s_no".toLowerCase()) {
        returnValue = widthEnum.minimumValueWidth;
      } else if (data.key !== undefined && data.key !== null && data.key === "") {
        returnValue = widthEnum.emptyFieldValueWidth;
      } else {
        if (!!data.grow && data.grow === 0) {
          returnValue = widthEnum.zeroGrow;
        } else if (!!data.grow && data.grow === 1) {
          returnValue = widthEnum.oneGrow;
        } else if (!!data.grow && data.grow === 2) {
          returnValue = widthEnum.twoGrow;
        } else {
          returnValue = parseInt(data.maxWidth.split("px")[0]);
        }
      }
    } else {
      if (data.key !== undefined && data.key !== null && (data.key.toLowerCase() === "s_no".toLowerCase() || data.key === "" || data.key.toLowerCase() === "id".toLowerCase())) {
        returnValue = widthEnum.minimumValueWidth;
      } else {
        if (!!data.grow && data.grow === 0) {
          returnValue = widthEnum.zeroGrow;
        } else if (!!data.grow && data.grow === 1) {
          returnValue = widthEnum.oneGrow;
        } else if (!!data.grow && data.grow === 2) {
          returnValue = widthEnum.twoGrow;
        }
      }
    }
    return returnValue;
  };
  const setMinWidth = (data) => {
    let returnValue = widthEnum.defaultWidth;
    if (!!data && !!data.minWidth && data.minWidth !== 0) {
      if (data.key !== undefined && data.key !== null && (data.key.toLowerCase() === "s_no".toLowerCase() || data.key === "")) {
        returnValue = widthEnum.minimumValueWidth;
      } else {
        if (!!data.grow && data.grow === 0) {
          returnValue = widthEnum.zeroGrow;
        } else if (!!data.grow && data.grow === 1) {
          returnValue = widthEnum.oneGrow;
        } else if (!!data.grow && data.grow === 2) {
          returnValue = widthEnum.twoGrow;
        } else {
          returnValue = parseInt(data.minWidth.split("px")[0]);
        }
      }
    } else {
      if (data.key !== undefined && data.key !== null && (data.key.toLowerCase() === "s_no".toLowerCase() || data.key === "" || data.key.toLowerCase() === "id".toLowerCase())) {
        returnValue = widthEnum.minimumValueWidth;
      } else {
        if (!!data.grow && data.grow === 0) {
          returnValue = widthEnum.zeroGrow;
        } else if (!!data.grow && data.grow === 1) {
          returnValue = widthEnum.oneGrow;
        } else if (!!data.grow && data.grow === 2) {
          returnValue = widthEnum.twoGrow;
        }
      }
    }
    return returnValue;
  };
  const generateTableColumn = (data) => {
    let returnArray = [];
    for (let i = 0; i < data.length; i++) {
      let tempObject = { ...data[i] };
      tempObject.Header = data[i].name;
      tempObject.id = i + "";
      if (!!data[i] && !!data[i].key && !!defaultSortField && data[i].key.toLowerCase() === defaultSortField.toLowerCase()) {
        sortId = i + "";
      } else if (!!data[i] && !!data[i].altKey && !!defaultSortField && data[i].altKey.toLowerCase() === defaultSortField.toLowerCase()) {
        sortId = i + "";
      }
      tempObject.accessor = !!data[i] && !!data[i].selector && data[i].selector !== "" ? data[i].selector : "";
      tempObject.maxWidth = data[i].maWidth ? data[i].maWidth : setMaxWidth(data[i]);
      tempObject.minWidth = data[i].miWidth ? data[i].miWidth : setMinWidth(data[i]);
      tempObject.sortable = !!data[i] && !!data[i].sortable && data[i].sortable === true ? true : false;
      if (data[i].cell) {
        tempObject.Cell = data[i].cell;
      } else {
        tempObject.accessor = !!data[i] && !!data[i].selector && data[i].selector !== "" ? data[i].selector : "";
      }
      if (data[i]?.isSticky) {
        tempObject.isSticky = data[i].isSticky;
      }
      tempObject.style = { wordBreak: "break-word" };
      returnArray.push(tempObject);
    }
    return returnArray;
  };
  const tableColumn = React.useMemo(() => generateTableColumn(columns), [columns]);
  const tableData = React.useMemo(() => {
    return data;
  }, [data]);

  //for tables of profile pages
  const generateSelectedDataObjectWithSNo = (data) => {
    let returnObject = {};
    for (let i = 0; i < data.length; i++) {
      if (!!data[i] && !!data[i].s_no && data[i].s_no !== "") {
        returnObject[data[i].s_no - 1] = true;
      }
    }
    return returnObject;
  };

  //for other tables
  const generateSelectedDataObjectWithID = (data) => {
    let returnObject = {};
    for (let i = 0; i < data.length; i++) {
      if (!!data[i] && !!data[i].id) {
        returnObject[data[i].id - 1] = true;
      }
    }
    return returnObject;
  };

  const renderReactTable = () => {
    setIsLoaderActive(true);
    setTimeout(() => {
      setIsLoaderActive(false);
    }, 10);
  };
  //used in case of profile-tables
  const isTableName = Object.keys(creditCostDetails).some((key) => key.toLowerCase() === tableName?.toLowerCase());

  return (
    <>
      {(!!tableColumn && !!tableData && tableData.length !== 0 && !!paginationTotalRows && !!paginationPerPage && !!paginationDefaultPage && !!paginationPerPage) || hideSelection ? (
        <StyledComponent hideBorder={hideBorder}>
          <Table
            columns={tableColumn}
            data={tableData}
            isTwoLevel={isTwoLevel}
            secondLevelRowDropdownValue={secondLevelRowDropdownValue}
            totalDataCount={paginationTotalRows}
            totalRowsCount={Math.ceil(paginationTotalRows / paginationPerPage)}
            currentPage={paginationDefaultPage - 1}
            tablePageSize={paginationPerPage}
            sortId={sortId}
            onSort={onSort}
            onChangePage={(param1, param2) => {
              onChangePage(param1, param2);
            }}
            onChangePerPage={(data) => {
              onChangeRowsPerPage(data);
            }}
            onTableObjectChange={(data) => {
              onTableObjectChange(data);
            }}
            shipmentDefaultSortValue={shipmentDefaultSortValue}
            onSelectedRowsChange={onSelectedRowsChange}
            selectedData={selectedData}
            selectedObject={isTableName ? generateSelectedDataObjectWithSNo(selectedData) : generateSelectedDataObjectWithID(selectedData)}
            isclearSelectedRows={clearSelectedRows}
            sortOrderValue={sortOrderValue}
            defaultSortField={defaultSortField}
            triggerSelectedDataObject={() => renderReactTable()}
            isLoader={isLoaderActive}
            noDataComponent={noDataComponent}
            hideSorting={hideSorting}
            hidePagination={hidePagination}
            isRedirect={isRedirect}
            currentUserPlan={currentUserPlan}
            pathname={pathname}
            analyticsCountryID={analyticsCountryID}
            hideSelection={hideSelection}
            clearFilter={clearFilter}
            type={type}
            fixSelection={fixSelection}
            options={options}
            isAtleastTwoColumnsSorted={isAtleastTwoColumnsSorted}
            blockAscSorting={blockAscSorting}
          />
        </StyledComponent>
      ) : tableData?.length === 0 ? (
        <div className="react-trademo-table">{noDataComponent ? <NoSearchDataComponent content={noDataComponent} /> : <></>}</div>
      ) : (
        <></>
      )}
    </>
  );
};
export default ReactTableTrademo;
